var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{'preview': !_vm.all, 'all': _vm.all}},[_c('code',{staticClass:"language-html"},[_vm._t("body")],2),_c('div',{staticClass:"show",on:{"click":function () { return _vm.all = !_vm.all; }}},[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }